// src/pages/auth/LoginPage.jsx

function LoginPage() {
    const loginUrl = import.meta.env.VITE_LOGIN_URL;
    const returnUrl = `${window.location.origin}`;

    location.href = `${loginUrl}?returnUrl=${encodeURIComponent(returnUrl)}`;
}

export default LoginPage;